import initSlider from '../sliders/initSlider';

document.addEventListener('DOMContentLoaded', (e) => {
  const awardsSlider = initSlider('[data-awards-slider]', awardsSliderOptions);

  const target = document.querySelector('[data-lifeline-chart]');
  const svgParts = target.querySelectorAll('.svg_part');

  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      svgParts.forEach((part) => {
        const order = part.dataset.order;
        part.classList.add(`svg_part--${order}`);
      });

      observer.unobserve(target);
    });
  };

  const observerOptions = {
    rootMargin: '0px',
    threshold: 0,
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);
  observer.observe(target);

  /*  */

  // const animateValue = (el, start, end, duration) => {
  //   let startTimestamp = null;

  //   const step = (timestamp) => {
  //     if (!startTimestamp) startTimestamp = timestamp;

  //     const progress = Math.min((timestamp - startTimestamp) / duration, 1);
  //     el.textContent = Math.floor(start + progress * (end - start));

  //     if (progress < 1) {
  //       window.requestAnimationFrame(step);
  //     }
  //   };

  //   window.requestAnimationFrame(step);
  // }

  // const counters = document.querySelectorAll('[data-count-to]');

  // counters.forEach((counter) => {
  //   const startValue = 0;
  //   const endValue = counter.dataset.countTo;
  //   const duration = 3000;

  //   animateValue(counter, startValue, endValue, duration);
  // });

});

const awardsSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 24,

  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },

  breakpoints: {
    1000: {
      slidesPerView: 1.5,
      pagination: {
        enabled: false,
      },
    },
  },
};
